import React from 'react';
import Modal from './Modal';
import { useInteractionStore } from '../../stores/useInteractionStore';

// Se recomienda renombrar este componente a ValidateTicketClosureModal
const ValidateTaskClosureModal = ({ isOpen, onClose, modalData }) => {
  const updateTicket = useInteractionStore((state) => state.updateTicket); // Asumimos que el store de soporte tiene una función `updateTicket`
  const selectedTicket = modalData?.ticket;

  if (!selectedTicket) return null;

  const handleValidation = (isValid) => {
    const status = isValid ? 'closed' : 'reopened'; // El flujo ahora es más claro: o se cierra o se reabre.
    updateTicket(selectedTicket._id, { status }); // Enviamos un objeto con los campos a actualizar
    onClose();
  };

  // 🟢 Comprobación robusta de la solución
  const hasSolution = selectedTicket.solution && selectedTicket.solution.trim() !== '';

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Validar Cierre de Ticket">
      <div className="space-y-4">
        <div>
          <h3 className="text-sm font-medium text-gray-500">Descripción del Ticket:</h3>
          <p className="mt-1 text-md text-gray-900 bg-gray-50 p-3 rounded-md border">
            {selectedTicket.description || 'No se proporcionó descripción.'}
          </p>
        </div>
        <div>
          <h3 className="text-sm font-medium text-gray-500">Solución Propuesta por el Técnico:</h3>
          <p className={`mt-1 text-md p-3 rounded-md border ${hasSolution ? 'text-gray-900 bg-gray-50' : 'text-red-700 bg-red-50'}`}>
            {hasSolution ? selectedTicket.solution : 'No se proporcionó una solución.'}
          </p>
        </div>
        <div className="pt-4 border-t">
          <p className="text-sm text-center text-gray-600">¿La solución proporcionada resuelve el problema original del ticket?</p>
        </div>
        <div className="flex justify-center space-x-4 pt-2">
          <button
            onClick={() => handleValidation(false)}
            className="px-6 py-2 text-sm font-semibold text-white bg-red-600 rounded-md hover:bg-red-700"
          >
            No, Reabrir Ticket
          </button>
          <button
            onClick={() => handleValidation(true)}
            className="px-6 py-2 text-sm font-semibold text-white bg-green-600 rounded-md hover:bg-green-700 disabled:bg-gray-400"
            disabled={!hasSolution}
          >
            Sí, Cerrar Ticket
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ValidateTaskClosureModal;